import React from 'react';

const Close: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    height="20"
    fill="none"
    viewBox="0 0 20 20"
    width="20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d={`M15.8333 5.34102L14.6583 4.16602L9.99996 8.82435L5.34163
      4.16602L4.16663 5.34102L8.82496 9.99935L4.16663 14.6577L5.34163
      15.8327L9.99996 11.1743L14.6583 15.8327L15.8333 14.6577L11.175
      9.99935L15.8333 5.34102Z`} fill="#C2C9D1"/>
    <path d={`M15.8333 5.34102L14.6583 4.16602L9.99996 8.82435L5.34163
      4.16602L4.16663 5.34102L8.82496 9.99935L4.16663 14.6577L5.34163
      15.8327L9.99996 11.1743L14.6583 15.8327L15.8333 14.6577L11.175
      9.99935L15.8333 5.34102Z`} fill="black" fillOpacity="0.25"/>
  </svg>
);

export default Close;
